import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const BurgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null); // Reference for the menu container

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Handle clicks outside the menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false); // Close the menu
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div>
            <button 
              onClick={toggleMenu} 
              className={`burger-button ${isOpen ? "burger-button-open" : ""}`}
              >
              {isOpen ? "→" : "☰"}
            </button>
            {isOpen && (
                <div ref={menuRef} className="burger-menu">
                    <Link to="/" onClick={toggleMenu}>Home</Link>
                    <Link to="/cab-tours" onClick={toggleMenu}>Cab Tours</Link>
                    <Link to="/tour-planning-tool" onClick={toggleMenu}>Tour Planner</Link>
                    <Link to="/blog" onClick={toggleMenu}>Blog</Link>
                    <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
                </div>
            )}
        </div>
    );
};

export default BurgerMenu;
